import { Component, Inject, OnInit } from '@angular/core';
import { PaymentComponent } from '../payment/payment.component';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { loadStripe, StripeCardElement } from '@stripe/stripe-js';
import { PaymentService } from 'src/app/services/payment-service/payment.service';
import { AuthService } from 'src/app/services/auth-service/auth.service';
import { DialogData } from '../nav/dashboardnav.component';

@Component({
  selector: 'app-pack',
  templateUrl: './pack.component.html',
  styleUrls: ['./pack.component.scss']
})
export class PackComponent implements OnInit {
  stripe: any;
    card: StripeCardElement | null = null;
    packType : string;
    userCount = 0;
    totalAmount = 0;
    currentUser = null;
    admin = false;
    type = 0;
    currentPack = 'free';
    //stripePromise = loadStripe('pk_test_51R22BxFLfoFgeSiXZVsLtVJUAafwuz7gp8mpfMrQcQdwG3B4T19cGBZ5fINZ19p28UuppWRpX8SDmB7RPPTfLeXo00t0Hnd534');
    //stripePromise = loadStripe('pk_test_51Rj76AFqvuHDQiWGVi0V6eYzGfuLWQqniCOdGeDPRxMWkZWF4Thl03kGfSgDiT9XYkNdJsDGfbOwHScvFGeBFtMy00d3nFJfLU');
    //pk_test_51R22CFFS8kUFVqJj4cE66DnsTM1xsCqvOPSU1mOCpySLeQRospuLJUmpPl1B0RZgtsYyOEdMJiwBC3BTvFWaqm5Y00OA1aOX3Z
    packOrder = ['starter', 'basic', 'medium', 'pro', 'gold'];
    storageLimits: { [key: string]: number } = {
      starter: 5,
      basic: 10,
      medium: 25,
      pro: 50,
      gold: 100
    };

  constructor(public  dialog: MatDialog, private paymentService: PaymentService, @Inject(MAT_DIALOG_DATA) public data: any, private authService: AuthService) { 
    this.type = data.type;
    this.currentPack = data.currentPack;
  }


  ngOnInit() {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.admin = this.currentUser.roles.includes('ROLE_MANAGER');
    this.authService.getCountAllContacts()
      .subscribe(res => {
        this.userCount = res['userCount'];
        this.totalAmount = this.userCount * 2.99;
      })
  }

  isDisabled(packName: string): boolean {
    const currentIndex = this.packOrder.indexOf(this.currentPack);
    const selectedIndex = this.packOrder.indexOf(packName);

    if (this.type === 1) {
      // Limite de stockage atteinte → Interdire pack identique ou inférieur
      return selectedIndex <= currentIndex;
    }

    if (this.type === 2) {
      // Abonnement expiré → Interdire pack inférieur
      return selectedIndex < currentIndex;
    }

    return false;
  }

  getCurrentStorageLimit(): string {
    const limit = this.storageLimits[this.currentPack];
    return limit ? `${limit} Go` : '200 Mo'; // fallback au cas où
  }

  logout() {
    this.authService.logout();
  }

  async checkout(packType: string) {
    /*const stripe = await this.stripePromise;
    //const { token, error } = await this.stripe.createToken(this.card);
    this.paymentService.createCheckoutSession({ packType: packType }).subscribe(async session => {
      if (stripe) {
        await stripe.redirectToCheckout({ sessionId: session.id });
      }
    });*/
  }

  openPaymentDialog(packType: string) {
    const dialogRef = this.dialog.open(PaymentComponent, {
      panelClass: 'transferclass',
      backdropClass: 'custom-backdrop',
      height: "calc(-80px + 100vh)",
      data: { packType: packType  } // Passer le type de pack au dialog
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }

  pay(packType: string) {
    this.openPaymentDialog(packType); // Ouvre le dialogue avec le pack sélectionné
  }

}
